export default class JobPlacementsReportRequest {
    startsWeekCommencing: string;
}